module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAMAAABo+94fAAAAYFBMVEUAAAAjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBUjGBWrwAYGAAAAH3RSTlMAEfn1b39+xLRRI+7p1OTeu4pHKByopp91Sj89Lw8FwhTdPAAAAJhJREFUGNNljwkOwyAMBNdAGyBHc/U+/P9fNgYUK2IkZGtYbIENCpPvu5a57Xo/hS+EeDV8wNwiMFuusDMGqcPjvdIPtIR7enpBCn+w80xxjOkSaJp80G9iRPS2DQCY88Grsz6icOLEGYpa8ZVVr9Y4ImeK16yTzpW8TiBpSeeIVb17qTokA0DW6MqElV9zhQewNOYorV/xB6YmGTCYRzlZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/blackPhone.png
// module id = yfBs
// module chunks = 1